import { generateAPI } from "../api.generator";
import { TicketAttachment } from "../../types/ticket";
import { MessageReplyTo } from "../../types/feedback";

export const shareFeedbackSettings = generateAPI<
  {
    body: {
      feedbackOptions: string;
      message: string;
      attachments?: TicketAttachment[];
      replyTo?: MessageReplyTo;
    };
  },
  any
>("post", "feedback");
